import React, { useContext, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import productData from "../Datas/productData";
import "../css/productdetails.scss";
import { CartContext } from "../Component/CartContext";
import ProductVisual from "./ProductVisual";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData.find((item) => item.id === parseInt(id));
  const { addToCart } = useContext(CartContext);

  const [selectedSize, setSelectedSize] = useState(product?.size?.[0] || "");
  const [selectedColor, setSelectedColor] = useState(
    product?.colors?.[0] || ""
  );

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!product) {
    return (
      <div className="product-detail">
        <div className="product-detail__not-found">
          <h2>Product not found</h2>
          <Link onClick={toTop} to="/shop">
            Back to Shop
          </Link>
        </div>
      </div>
    );
  }

  const handleAddToCart = () => {
    addToCart(product.id, 1, selectedSize, selectedColor);
    navigate("/cartpage");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="product-detail">
      <div className="product-detail__container">
        <div className="gallery-column">
          <div className="main-image-container">
            <div className="main-image">
              <ProductVisual product={product} />
            </div>
          </div>
          <p className="artwork-note">AI-generated visual based on the listed product name, material and construction. It is not a photograph of production stock; the final item may differ.</p>
        </div>
        <aside className="product-info">
          <div className="product-breadcrumbs">
            {product.category}
            {product.category && " — "}
            {product.category === "Accessories" ? "CAPS" : ""}
          </div>
          <h1 className="product-name">{product.name}</h1>
          <div className="product-price">${product.price}</div>
          <p className="preview-badge">PREVIEW CATALOGUE — NOT CURRENTLY AVAILABLE FOR ONLINE PURCHASE</p>
          {product.size && product.size.length > 0 && (
            <div className="product-options-section">
              <div className="option-label">SIZE</div>
              <div className="size-options">
                {product.size.map((size, idx) => (
                  <button
                    key={idx}
                    className={`size-btn ${
                      selectedSize === size ? "active" : ""
                    }`}
                    onClick={() => setSelectedSize(size)}
                  >
                    {size}
                  </button>
                ))}
              </div>
            </div>
          )}
          {product.colors && product.colors.length > 0 && (
            <div className="product-options-section">
              <div className="option-label">COLOR</div>
              <div className="size-options">
                {product.colors.map((size, idx) => (
                  <button
                    key={idx}
                    className={`size-btn ${
                      selectedColor === size ? "active" : ""
                    }`}
                    onClick={() => setSelectedColor(size)}
                  >
                    {size}
                  </button>
                ))}
              </div>
            </div>
          )}
          <button className="add-to-cart-btn" onClick={handleAddToCart}>
            ADD TO SELECTION
          </button>
          <div className="shipping-info">
            <p>ONLINE PAYMENT IS NOT CURRENTLY ENABLED.</p>
            <p>Pricing and availability must be confirmed before purchase.</p>
          </div>
          <div className="product-description">
            {product.description.map((p, idx) => (
              <p key={idx}>{p}</p>
            ))}
            <p><strong>Material:</strong> {product.material}</p>
          </div>
          <div className="details-care">
            <div className="details-section">
              <div className="section-header">
                <h4>DETAILS</h4>
                <span className="toggle-btn" aria-hidden="true">−</span>
              </div>
              <div className="section-content">
                <ul>
                  {product.Features.map((f, idx) => (
                    <li key={idx}>{f}</li>
                  ))}
                </ul>
              </div>
            </div>
            {product.washcare && product.washcare.length > 0 && (
              <div className="details-section">
                <div className="section-header">
                  <h4>WASHCARE</h4>
                  <span className="toggle-btn" aria-hidden="true">−</span>
                </div>
                <div className="section-content">
                  <ul>
                    {product.washcare.map((wc, idx) => (
                      <li key={idx}>{wc}</li>
                    ))}
                  </ul>
                </div>
              </div>
            )}
          </div>
        </aside>
      </div>
    </div>
  );
};

export default ProductDetail;
